// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c99cecf1","239":"838e470d","455":"c05ab7c3","488":"bb04d538"}[chunkId] + ".chunk.js";
};